<template>
    <div class="frame"
         :class="{
             'p-0': noSpacing,
             'has--shadow': shadow,
             'bg-white': !transparent
         }">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'Frame',
        props: {
            noSpacing: {
                type: Boolean,
                default: false
            },
            shadow: {
                type: Boolean,
                default: true
            },
            transparent: {
                type: Boolean,
                default: false
            }
        }
    }
</script>